<script>

export let author;
export let comment;

// Adjusts position of comment bubble to center and keep within viewport

</script>

<style type="text/sass">

.wrap
  display: inline
  position: relative
  cursor: pointer

.comment
  position: absolute
  display: flex
  flex-direction: column
  bottom: 150%
  width: max-content
  max-width: 350px
  padding: 1em 1.5em
  background: white
  font-size: 0.8em
  border-radius: 10px
  transition-duration: 0.3s
  visibility: hidden
  opacity: 0
  z-index: 20

.wrap:hover .comment
  visibility: visible
  opacity: 1

@media (max-width: 700px)
  .comment
    max-width: 80vw


</style>

<div class="wrap">
  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -2 24 24"><path d="M18 7c.542 0 1 .458 1 1v7c0 .542-.458 1-1 1h-8.829l-.171.171v-.171h-3c-.542 0-1-.458-1-1v-7c0-.542.458-1 1-1h12m0-2h-12c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h1v3l3-3h8c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3z"/></svg>
  <div class="comment">
    <div>
      <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" style="margin-bottom: -5px"><path d="M18 7c.542 0 1 .458 1 1v7c0 .542-.458 1-1 1h-8.829l-.171.171v-.171h-3c-.542 0-1-.458-1-1v-7c0-.542.458-1 1-1h12m0-2h-12c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h1v3l3-3h8c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3z"/></svg>
      <b>{author}</b>
    </div>
    <div>{comment}</div>
  </div>
</div>
